import React from "react";
import Bugsnag from "@bugsnag/js";
import {configureStore} from "./redux/store";

// NOTE: Exports defined in this file so they won't create multiple rendering with hot reload

export const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

export const store = configureStore();
